import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-createaccessmanagement',
  templateUrl: './createaccessmanagement.component.html',
  styleUrls: ['./createaccessmanagement.component.css']
})
export class CreateaccessmanagementComponent implements OnInit {
  returnUrl= "/dashboard/createaccessmanagementone";
  constructor(private router: Router) { }

  ngOnInit(): void {
    $('.selectpicker').selectpicker('refresh');
  }
  createaccessone(){
    this.router.navigate([this.returnUrl]);
  }
}
